import React from "react";
import {
  RestChildICon,
  StyledThumbImage,
  StyledThumbImage2,
} from "../../Pages/ChildTimeline/styles";

import { Badge } from "reactstrap";
import { Link } from "react-router-dom";
import { useAtom } from "jotai";
import { appConstants } from "../../AtomStore/store";

const ChildTimelineItem = (props) => {
  const [constants] = useAtom(appConstants);

  const { items } = props;

  return (
    <li className="mb-4">
      {/* <h3 className="text-header font-semibold p-2 rounded-full bg-header/20 text-center mb-2">
        {items.dateGroup === moment().format('DD-MM-YY')
          ? 'Today'
          : moment(items.dateGroup, 'DD-MM-YY').format(DEFAULT_FORMAT)}
      </h3> */}
      {items.data.map((item, Index) => (
        <div
          key={Index}
          className="grid grid-cols-12 gap-2 items-start border-b py-3"
        >
          <div className="col-span-10">
            <div className="flex items-start gap-3  grid-cols-12">
              <div className="col-span-2 flex items-start">
                {item.linkImg !== "" ? (
                  <Badge
                    pill
                    className="bg-white flex items-end"
                    style={{
                      width: "45px",
                      height: "45px",
                      padding: 0,
                      borderRadius: "50px !important",
                      overflow: "hidden",
                    }}
                  >
                    {item.navigateTo ? (
                      item.type === "Image" ? (
                        <Link
                          to={`/${item.navigateTo}`}
                          className="w-full h-full"
                        >
                          <StyledThumbImage
                            className="w-100 h-100"
                            alt="Fp_Linkthumb"
                            src={
                              constants?.TimeLineThumbUrl + "/" + item.message
                            }
                          />
                        </Link>
                      ) : (
                        <Link
                          to={`/${item.navigateTo}`}
                          className="w-full h-full flex items-center justify-center"
                        >
                          {item.type === "Attendance" ? (
                            <StyledThumbImage2
                              alt="Fp_Linkthumb"
                              src={item.linkImg}
                            />
                          ) : (
                            <StyledThumbImage
                              alt="Fp_Linkthumb"
                              src={item.linkImg}
                            />
                          )}
                        </Link>
                      )
                    ) : (
                      <img
                        alt="Fp_Linkthumb"
                        src={item.linkImg}
                        style={{
                          width: "45px",
                          height: "45px",
                        }}
                      />
                    )}
                  </Badge>
                ) : (
                  <Badge
                    pill
                    className="badge-success"
                    style={{
                      width: "45px",
                      height: "45px",
                      backgroundColor: "#c4f2e0 !important",
                      borderRadius: "50px !important",
                      overflow: "hidden",
                    }}
                  >
                    <RestChildICon />
                  </Badge>
                )}
              </div>
              <p className="text-lg font-semibold leading-5 col-span-10">
                {item.type} <br />{" "}
                <span className="text-xs font-normal">
                  {item.type === "Image" ? "Click here" : " " + item.message}
                </span>
              </p>
            </div>
          </div>
          <p className="col-span-2 text-md text-center leading-1">
            <span className="font-semibold ">
              {item.time.split(" ")[0].toUpperCase()}
            </span>{" "}
            <br />
            {item.time.split(" ")[1].toUpperCase()}
          </p>
        </div>
      ))}

      {/* <li className="grid grid-cols-12 gap-2 items-center mt-3">
          <p className=" col-span-3 text-md text-center font-extrabold leading-4">
            09:20 <br />
            Am
          </p>
          <span className=" col-span-1 h-5 w-5 bg-header rounded-full inline-block"></span>
          <div className="col-span-8">
            <p className="  text-lg font-extrabold leading-5 ml-4 mt-2">
              Activity <br />{' '}
              <span className="text-xs font-normal">Did cycling activity</span>
            </p>
            <hr className="mt-2 w-full bg-dark text-dark" />
          </div>
        </li>
        <li className="grid grid-cols-12 gap-2 items-center mt-3">
          <p className=" col-span-3 text-md text-center font-extrabold leading-4">
            09:45 <br />
            Am
          </p>
          <span className=" col-span-1 h-5 w-5 bg-header rounded-full inline-block"></span>
          <div className="col-span-8">
            <p className="  text-lg font-extrabold leading-5 ml-4 mt-2">
              Sleep <br />{' '}
              <span className="text-xs font-normal">Sleep at 9:45 am</span>
            </p>
            <hr className="mt-2 w-full bg-dark text-dark" />
          </div>
        </li> */}
    </li>
  );
};

export default ChildTimelineItem;
